import api from './api';

export const getMensagens = async (params) => {
  const { data } = await api.get('/mensagens', { params });
  return data;
};

export const getMensagemById = async (id) => {
  const { data } = await api.get(`/mensagem/${id}`);
  return data;
};

export const createMensagem = async (mensagem) => {
  const { data } = await api.post('/mensagens', mensagem);
  return data;
};

export const updateMensagem = async (id, mensagem) => {
  const { data } = await api.put(`/mensagens/${id}`, mensagem);
  return data;
};
